import { FaLine } from "react-icons/fa6";

export const StickyMobileCTA = ({ lineUrl }) => {
  return (
    <div
      className="fixed bottom-0 left-0 right-0 z-40 border-t border-gold/20 bg-creamLight/95 px-4 py-3 shadow-soft backdrop-blur sm:hidden"
      data-testid="sticky-mobile-cta"
    >
      <a
        href={lineUrl}
        target="_blank"
        rel="noreferrer"
        className="flex w-full items-center justify-center gap-2 rounded-full bg-line px-4 py-3 text-sm font-semibold text-white shadow-glow-line transition-shadow duration-300 hover:shadow-[0_0_26px_rgba(0,195,0,0.7)]"
        data-testid="sticky-mobile-cta-button"
        aria-label="ทัก LINE ตอนนี้"
      >
        <FaLine className="text-lg" data-testid="sticky-mobile-cta-icon" />
        <span data-testid="sticky-mobile-cta-text">ทัก LINE ตอนนี้</span>
      </a>
    </div>
  );
};